/**
 * Thin wrapper around the shared ui-kit agent widget.
 *
 * The widget itself lives at `@isg/ui-kit` `renderAgentWidget` so every
 * ISG app mounts the same implementation (SSE streaming, nav chips,
 * two-phase confirm, attachments). This file supplies the pricing-
 * specific labels + suggestions, then delegates.
 *
 * The assistant is how-to for every pricing user and adds operational +
 * action tools for admins. It never surfaces prices/costs/margins — for
 * those it points you at the page.
 */
import { renderAgentWidget } from '@isg/ui-kit';

const SUGGESTIONS = [
  'How do I create and publish a price book?',
  'Is a vendor sync running right now?',
  'Which vendor keys are failing?',
  'Explain the default quote strategy',
  'How many recommendations are pending?',
];

export function renderAIAssistant(container) {
  renderAgentWidget(container, {
    appSlug: 'pricing',
    title: 'Pricing Assistant',
    placeholder: 'Ask how to use the app, check status, or trigger a sync…',
    suggestions: SUGGESTIONS,
  });
}
